import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import axios from "@/libs/api.request";
import axios2 from "@/libs/api.request2";
import { chuku } from "./api_url";
export var get_table_data = function get_table_data(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.list_data,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var add_table_data = function add_table_data(data) {
  var country_code = localStorage.getItem("country_code");
  data.append("country_code", country_code);
  return axios.request({
    url: chuku.add_list_data,
    data: data,
    method: "post"
  }, "FormData");
};
export var del_table_data = function del_table_data(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.del_list_data,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var download_life = function download_life(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.download_life,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var get_token = function get_token(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_token,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var edit_platform = function edit_platform(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.edit_platform,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var get_effective_router = function get_effective_router(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_effective_router,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var get_effective_router_data = function get_effective_router_data(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_effective_router_data,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var get_qr_code = function get_qr_code(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_qr_code,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var get_website_data = function get_website_data() {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_website_data,
    method: "post",
    data: {
      company_code: "PACEIC",
      country_code: country_code
    }
  });
};
export var download_data = function download_data(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.download_data,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var del_download = function del_download(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.del_download,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var get_device4g = function get_device4g(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_device4g,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var get_left_data4g = function get_left_data4g(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_left_data4g,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var get_4g_broken_line = function get_4g_broken_line(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_4g_broken_line,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var get_danti_view = function get_danti_view(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_danti_view,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var sn_file_log = function sn_file_log(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.sn_file_log,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var get_project_listinfo = function get_project_listinfo(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_project_listinfo,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var get_import_sn_did = function get_import_sn_did(data) {
  var country_code = localStorage.getItem("country_code");
  data.append("country_code", country_code);
  return axios.request({
    url: chuku.get_import_sn_did,
    data: data,
    method: "post"
  });
};
export var import_sn = function import_sn(data) {
  var country_code = localStorage.getItem("country_code");
  data.append("country_code", country_code);
  return axios.request({
    url: chuku.import_sn,
    data: data,
    method: "post"
  });
};
export var getinfoData = function getinfoData(data) {
  var country_code = localStorage.getItem("country_code");
  return axios2.request({
    url: chuku.get_info_data,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var editinfoData = function editinfoData(data) {
  var country_code = localStorage.getItem("country_code");
  return axios2.request({
    url: chuku.edit_info_data,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var get_qgl_data = function get_qgl_data(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_qgl_data,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var get_qgl_broken_line = function get_qgl_broken_line(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_qgl_broken_line,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
export var dldpget = function dldpget(data) {
  return axios.request({
    url: '/index.php/admin/dp/web_dpget',
    data: _objectSpread({}, data),
    method: "post"
  });
};
export var dldpset = function dldpset(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: '/index.php/admin/dp/web_dpset',
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
}; //批量设置，产品型号pl_cpxh

export var pl_list = function pl_list(data) {
  return axios.request({
    url: chuku.pl_list,
    data: _objectSpread({}, data),
    method: "post"
  });
}; //获取电柜状态

export var get_4g_data_dg = function get_4g_data_dg(data) {
  return axios.request({
    url: '/index.php/admin/device4g/get_4g_data_dg',
    data: _objectSpread({}, data),
    method: "post"
  });
}; //是否支持修改packsn

export var editPackSn = function editPackSn(data) {
  return axios.request({
    url: '/index.php/admin/device/check_support_dp',
    data: _objectSpread({}, data),
    method: "post"
  });
};